import { ITelemetryLogger } from '../../interfaces/ITelemetryLogger';
import { OTelTelemetryLogger } from './OTelTelemetryLogger';

/**
 * An enum to define the types of loggers, available to LoggerFactory.
 * Factory method in LoggerFactory will return an instance, based on the LoggerType provided by client.
 *
 * @see LoggerFactory
 */
export enum LoggerType {
  OTelBasedLogger = 1
}

/**
 * A public factory function to create ITelemetryLogger instances based on the LoggerType.
 *
 * @param loggerType Type of logger to be created by factory, defined by LoggerType.
 * @returns A telemetry logger instance, which can be referred by ITelemetryLogger interface.
 *
 * @see LoggerType
 * @see ITelemetryLogger
 */
export function createLoggerInstance(loggerType: LoggerType): ITelemetryLogger {
  switch (loggerType) {
    case LoggerType.OTelBasedLogger:
      return new OTelTelemetryLogger();

    default:
      return new OTelTelemetryLogger();
  }
}
